import developerPermissionsApi from "../../../api/developer_permissions";

export type RoleKey = string;

export type PermissionRow = {
  permission_key: string;
  entrypoint: string;
  required_entitlements: string[];
  required_context_keys: string[];
  required_credentials_keys: string[];
  roles_allowed: Record<RoleKey, boolean>;
};

export type DeveloperPermissionsMatrix = {
  roles: RoleKey[];
  permissions: PermissionRow[];
};

type DeveloperPermissionsActions = {
  fetchMatrix(): Promise<DeveloperPermissionsMatrix | null>;
};

export const createDeveloperPermissionsActions = (): DeveloperPermissionsActions => ({
  fetchMatrix() {
    return new Promise((resolve) => {
      developerPermissionsApi.fetch((data: DeveloperPermissionsMatrix | null | undefined) => {
        resolve(data ?? null);
      });
    });
  }
});
